import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from '../baseApiService';
import { AuthenticationService } from '../../auth/authentication-service';
import { SparePartsResponse } from './sparePartsResponse';
import { SingleSparePart } from './singleSparePart';
import { SparePartsImportResponse } from './sparePartsImportResponse';

@Injectable({
  providedIn: 'root'
})
export class SparePartsApiService extends BaseApiService {
  constructor(http: HttpClient, authService: AuthenticationService) {
    super(http, authService);
  }

  getSparePart(sparePartId: number): Observable<SingleSparePart> {
    return this.http.get<SingleSparePart>(`${this.apiUrl}/api/v5/spare-parts/${sparePartId}`).pipe(
      catchError(this.handleError<SingleSparePart>('getSparePart', undefined))
    );
  }

  getAssetSpareParts(assetId: string): Observable<SparePartsResponse> {
    return this.http.get<SparePartsResponse>(`${this.apiUrl}/api/v5/assets/${assetId}/spare-parts`).pipe(
      catchError(this.handleError<SparePartsResponse>('getAssetSpareParts', undefined))
    );
  }

  importSpareParts(formData: FormData): Observable<SparePartsImportResponse> {
    return this.http.post<SparePartsImportResponse>(`${this.apiUrl}/api/v5/spare-parts/import`, formData);
  }
}
